import { render, staticRenderFns } from "./PointPresent.vue?vue&type=template&id=84f38d46"
import script from "./PointPresent.vue?vue&type=script&lang=js"
export * from "./PointPresent.vue?vue&type=script&lang=js"
import style0 from "./PointPresent.vue?vue&type=style&index=0&id=84f38d46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports